/* Profil liczby (Fala 7A, 26.09.2026): dwie rzeczy, bez przebudowy SSR.
 *  1. Formularz: bez JS serwer przekierowuje `?liczba=X&okno=Y` na kanoniczne
 *     /gra/liczba/X?okno=Y. Z JS idziemy tam od razu (bez 302). Rok ma
 *     pierwszenstwo przed oknem — ta sama regula co w engine.
 *  2. Eksport CSV/JSON z danych osadzonych w stronie (ten sam zakres co widok).
 * Numer liczby NIGDY nie idzie w `?n=` — trasa ma go w sciezce. */
(function (root, doc) {
    'use strict';
    var box = doc.querySelector('[data-profil]');
    if (!box || box.getAttribute('data-profil-js') === '1') { return; }
    box.setAttribute('data-profil-js', '1');

    var form = box.querySelector('[data-profil-form]');
    if (form) {
        form.addEventListener('submit', function (e) {
            var liczba = form.querySelector('[data-profil-liczba]');
            var rok = form.querySelector('[data-profil-rok]');
            var start = form.querySelector('[data-profil-start]');
            var okno = form.querySelector('input[name="okno"]:checked');
            var n = liczba ? parseInt(liczba.value, 10) : NaN;
            if (!(n >= 1)) { return; }   // serwer sam oceni zle wejscie
            var akcja = form.getAttribute('action') || '';
            var baza = akcja.replace(/\/[0-9]+(?:\?.*)?$/, '/');
            if (!/\/$/.test(baza)) { return; }
            var q = rok && /^(19|20)[0-9]{2}$/.test(rok.value) ? 'rok=' + rok.value : 'okno=' + encodeURIComponent(okno ? okno.value : '7');
            if ((!rok || !/^(19|20)[0-9]{2}$/.test(rok.value)) && start && /^[1-9][0-9]*$/.test(start.value)) {
                q += '&start=' + encodeURIComponent(start.value);
            }
            e.preventDefault();
            root.location.assign(baza + n + '?' + q);
        });
    }

    var source = box.querySelector('[data-profil-export]');
    if (!source) { return; }
    var report;
    try { report = JSON.parse(source.textContent); } catch (e) { return; }
    function save(text, type, extension) {
        var blob = new Blob([extension === 'csv' ? '﻿' + text : text], { type: type });
        var url = URL.createObjectURL(blob);
        var a = doc.createElement('a');
        a.href = url;
        a.download = 'number-profile-' + report.game + '-' + report.number + '-' + report.range_type + '-' + report.range_value + '.' + extension;
        doc.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { URL.revokeObjectURL(url); }, 0);
    }
    function cell(value) {
        if (value === null || value === undefined) { return ''; }
        var s = typeof value === 'object' ? JSON.stringify(value) : String(value);
        return '"' + s.replace(/"/g, '""') + '"';
    }
    box.addEventListener('click', function (event) {
        var button = event.target.closest ? event.target.closest('[data-profil-export-format]') : null;
        if (!button) { return; }
        if (button.getAttribute('data-profil-export-format') === 'json') {
            save(JSON.stringify(report, null, 2), 'application/json;charset=utf-8', 'json');
            return;
        }
        var keys = Object.keys(report).filter(function (key) { return key !== 'partners'; });
        save(keys.map(cell).join(';') + '\r\n' + keys.map(function (key) { return cell(report[key]); }).join(';') + '\r\n', 'text/csv;charset=utf-8', 'csv');
    });
})(window, document);
